export default __webpack_public_path__ + "static/media/menu-16x12.2fcd8a3e.svg";